import React from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import styled from "styled-components"

const ArrowLeft = ({ onClick }) => (
  <button
    className="text-center p-4 top-20 -left-2 md:block hidden rounded-full lg:-left-40 lg:top-40 top-30 absolute z-10 bg-gray-300 focus:outline-none"
    onClick={onClick}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807612 11.0711 0.807612 10.4853 1.3934L0.93934 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z" fill="#000000" />
    </svg>
  </button>
)
ArrowLeft.propTypes = {
  onClick: PropTypes.func,
}

const ArrowRight = ({ onClick }) => (
  <button
    className="text-center p-4 top-20 -right-2 md:block hidden rounded-full lg:-right-40 lg:top-40 absolute z-10 bg-gray-300 focus:outline-none"
    onClick={onClick}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.0607 10.9393C21.6464 11.5251 21.6464 12.4749 21.0607 13.0607L11.5147 22.6066C10.9289 23.1924 9.97919 23.1924 9.3934 22.6066C8.80761 22.0208 8.80761 21.0711 9.3934 20.4853L17.8787 12L9.3934 3.51472C8.80761 2.92893 8.80761 1.97919 9.3934 1.3934C9.97919 0.807611 10.9289 0.807611 11.5147 1.3934L21.0607 10.9393ZM0 10.5L20 10.5V13.5L0 13.5L0 10.5Z" fill="black" />
    </svg>
  </button>
)
ArrowRight.propTypes = {
  onClick: PropTypes.func,
}

const ArtistCarousel = ({ artists }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <ArtistContainer className="m-auto text-center">
      <Slider {...settings}>
        {
          artists && artists.map((artist, index) => (
            <div key={index} className="p-4 rounded-2xl">
              <img
                src={artist.image.childImageSharp.fluid.src}
                alt=""
                className="w-full"
                style={{ maxWidth: "435px", borderRadius: "10px" }}
              />
              <h3
                className="text-white text-bold text-center inline font-serif rounded-2xl
                  -mt-12 uppercase opacity-90 text-4xl bg-purple-300 lg:px-15 p-5 lg:py-5 py-5
                  text-yellow-300"
              >
                {artist.name}
              </h3>
            </div>
          ))
        }
      </Slider>
    </ArtistContainer>
  )
}

ArtistCarousel.propTypes = {
  artists: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
}
const ArtistContainer = styled.div`
width: 995px;
margin: auto;
text-align: center;
@media (max-width: 768px) {
    max-width: 400px;
    margin: auto;
    text-align: center;
  }
`
export default ArtistCarousel
